// push.ts — Endpoints Web Push (abonnement aux notifications de rappel).
import { req } from './_internals.js';

export interface VapidKeyResponse {
  enabled: boolean;
  public_key: string | null;
}

export interface PushSubscribePayload {
  endpoint: string;
  keys: { p256dh: string; auth: string };
  user_agent?: string;
}

export const pushApi = {
  getVapidPublicKey: () => req<VapidKeyResponse>('GET', '/push/vapid-public-key'),
  subscribePush: (d: PushSubscribePayload) => req('POST', '/push/subscribe', d),
  unsubscribePush: (endpoint: string) => req('POST', '/push/unsubscribe', { endpoint }),
};
